import React, { Component } from "react";

export class TermsOfUseFooter extends Component {
	render() {
		return (
			<div className="terms-of-use-footer">
			    <div className="dx-col terms">
				<span><a href="https://privateclientselect.com/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a></span>
<span><a href="https://privateclientselect.com/privacy-notice" target="_blank" rel="noopener noreferrer">Privacy</a></span>
<span><a href="https://privateclientselect.com/legal-notice" target="_blank" rel="noopener noreferrer">Legal Notice</a></span>
			    </div>
			    <div className="dx-col copyright">
				<span> Copyright &copy; 2026 Private Client Select Insurance Services LLC.</span>
						<span> All rights reserved.  </span><br></br>
					<span className="lapsed-text textleft">Private Client Select is the marketing name for Private Client Select Insurance Services LLC, a licensed property/casualty insurance producer with its principal place of business in Florida, and operating in all U.S. states and the District of Columbia. The communications on this website are for informational purposes only and are not a binding offer of coverage. Insurance coverage is subject to underwriting review and approval. Coverage may not be available in all jurisdictions. See the insurance policy for a complete description of its terms, scope, and limitations of coverage. In CA, Private Client Select d/b/a PC Select Insurance Services, CA License #s 6009488 and 2N60097</span>
			    </div>
			</div>
		)
	}
};



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/TermsOfUseFooter/TermsOfUseFooter.js